import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { IdGenerator } from "../helpers/IdGenerator";

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldComponent implements OnInit {

  @Input() label: string = "";
  @Input() type: string = "text";
  @Input() placeholder: string = "";
  @Input() value: string = "";
  @Input() disabled: boolean = false;
  @Input() autocomplete: string = "";
  @Input() name: string = "";

  @Output() enterPressed = new EventEmitter();
  @Output() valueChanged = new EventEmitter();
    
  
  uniqueID: string = IdGenerator.generate(3);

  constructor() { }

  ngOnInit() {
  }

  onValueChange(e) {
    this.value = e.target.value;
    if(e.keyCode == 13){ //Enter
      this.enterPressed.emit();
    }
    else {
      this.valueChanged.emit(this.value);
    }
  }

}
